/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LengthUnit } from './LengthUnit';
import {
    LengthUnitFromJSON,
    LengthUnitFromJSONTyped,
    LengthUnitToJSON,
    LengthUnitToJSONTyped,
} from './LengthUnit';

/**
 * A custom update schema, which can be used by logged in users to update some parts of their own profile. Normal users are much more restricted regarding permissions.
 * @export
 * @interface LoggedInUserUpdate
 */
export interface LoggedInUserUpdate {
    /**
     * 
     * @type {string}
     * @memberof LoggedInUserUpdate
     */
    password?: string | null;
    /**
     * 
     * @type {LengthUnit}
     * @memberof LoggedInUserUpdate
     */
    lengthUnit?: LengthUnit | null;
}



/**
 * Check if a given object implements the LoggedInUserUpdate interface.
 */
export function instanceOfLoggedInUserUpdate(value: object): value is LoggedInUserUpdate {
    return true;
}

export function LoggedInUserUpdateFromJSON(json: any): LoggedInUserUpdate {
    return LoggedInUserUpdateFromJSONTyped(json, false);
}

export function LoggedInUserUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoggedInUserUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'] == null ? undefined : json['password'],
        'lengthUnit': json['lengthUnit'] == null ? undefined : LengthUnitFromJSON(json['lengthUnit']),
    };
}

export function LoggedInUserUpdateToJSON(json: any): LoggedInUserUpdate {
    return LoggedInUserUpdateToJSONTyped(json, false);
}

export function LoggedInUserUpdateToJSONTyped(value?: LoggedInUserUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'lengthUnit': LengthUnitToJSON(value['lengthUnit']),
    };
}

